// @ts-strict-ignore
import { Material } from 'three';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { CustomArticleUtils } from '@article/util/custom-article-utils';
import { TextureAreaVO } from '@shared/vo/meta-element.vo';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { IArticleTextureParameters } from './i-article-texture-parameters';
import { CustomArticleTextureParameters } from './custom-article-texture-parameters';
import { IArticleTextureParametersGenerator } from './i-article-texture-parameters-generator';
import { DefinedMetaElementInfoPropertyDef } from '../../../constants/defined-meta-element-info-property-def';
import { NumberUtils } from '@shared/util/number-utils';
import { ProjectUserModel } from '../../../model/project-user.model';
import { IsThreeJsType } from '@3d-scene/common/util/is-threejs-type';

export class CustomArticleTextureParametersGenerator implements IArticleTextureParametersGenerator {
  constructor(private projectUserModel: ProjectUserModel) {}

  public generateParameters(articleContainer: ArticleContainer, material: Material): IArticleTextureParameters {
    if (!articleContainer || !material || !((material as any).hasOwnProperty('map') && IsThreeJsType.texture((material as any)['map']))) {
      return null;
    }
    const imageArea: TextureAreaVO = CustomArticleUtils.getCustomImageArea(articleContainer.article);
    if (!imageArea) {
      return null;
    }
    const customImageHash: string = ArticleUsageUtils.getDefinedMetaElementInfoPropertyStringValue(
      articleContainer.articleUsage,
      imageArea.name,
      DefinedMetaElementInfoPropertyDef.CUSTOM_IMAGE_HASH
    );
    if (!customImageHash) {
      return null;
    }
    let userId: number = CustomArticleUtils.getCustomImageUserId(articleContainer.articleUsage);
    if (!NumberUtils.isNumber(userId)) {
      userId = this.projectUserModel.getProjectOwnerId();
    }
    return new CustomArticleTextureParameters(material, userId, customImageHash);
  }
}
